<template>
  <bita-modal id="doctor-form" :title="title" :modal-lg="true" :is-loading="isLoading" @close="reset">
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">

            <bita-input type="text" name="name" label="نام پزشک" rules="required" :validation-container-class="col6"
              input-class="form-control" v-model="form.name" />

            <bita-select name="degree_id" label="مدرک تحصیلی" rules="required" :validation-container-class="col6"
              :data-source="degrees" data-text-field="name" data-value-field="id" v-model="form.degree_id" />

            <bita-select name="specialty_id" label="تخصص" :validation-container-class="col6" :data-source="specialties"
              data-text-field="name" data-value-field="id" v-model="form.specialty_id" />

            <bita-input type="text" name="medical_system_code" label="کد نظام پزشکی" :validation-container-class="col6"
              input-class="form-control" v-model="form.medical_system_code" />

            <bita-select name="gender" label="جنسیت" :validation-container-class="col6" :data-source="[
              { id: 1, name: 'مرد' },
              { id: 2, name: 'زن' },
            ]" input-class="form-control" data-text-field="name" data-value-field="id" v-model="form.gender" />
            <!-- <br>
            <select v-model="form.gender" :class="`${col6} form-control`">
                <option value="1">مرد</option>
                <option value="2">زن</option>
            </select> -->

            <bita-input type="text" name="mobile" label="موبایل" :validation-container-class="col6"
              input-class="form-control" v-model="form.mobile" />

            <bita-input type="text" name="phone" label="تلفن" :validation-container-class="col6"
              input-class="form-control" v-model="form.phone" />

            <bita-input type="text" name="email" label="ایمیل" :validation-container-class="col6"
              input-class="form-control" v-model="form.email" />

            <bita-input type="text" name="address" label="آدرس" :validation-container-class="col6"
              input-class="form-control" v-model="form.address" />

            <bita-textarea type="text" name="about" label="درباره پزشک" :validation-container-class="col12"
              input-class="form-control" v-model="form.about" rowspan="5" />

            <bita-input type="text" name="social_networks" label="شبکه‌های اجتماعی" :validation-container-class="col6"
              input-class="form-control" v-model="form.social_networks" />

            <bita-uploader name="image" label="تصویر پزشک" rules="size:2048" ref="uploader"
              :validation-container-class="col6" input-class="form-control" v-model="form.image"
              :icon-url="form.image" />
            <hr />

            <bita-checkbox name="is_inplace_payment" label="پرداخت درمحل" :validation-container-class="col4"
              input-class="form-control" v-model="form.is_inplace_payment" />

            <bita-checkbox name="is_pre_payment" label="پیش پرداخت" :validation-container-class="col4"
              input-class="form-control" v-model="form.is_pre_payment" />

            <bita-checkbox name="is_online_payment" label="پرداخت آنلاین" :validation-container-class="col4"
              input-class="form-control" v-model="form.is_online_payment" />

            <div :class="col6">
              <bita-input min="0" rules="required" name="payment" :has-thousand-seprator="true"
                :label="$currencyLabel('حق ویزیت')" input-class="form-control" v-model="form.payment" />

              <div v-if="form.payment" class="mt-1" style="font-size: 13px;color: #000;font-style:bold;">
                {{ numberToWordsWrapper(form.payment) }}
              </div>
            </div>


            <div :class="col6">
              <bita-input min="0" rules="required" :has-thousand-seprator="true" name="pre_payment"
                :label="$currencyLabel('پیش پرداخت')" input-class="form-control" v-model="form.pre_payment" />

              <div v-if="form.pre_payment" class="mt-1" style="font-size: 13px;color: #000;font-style:bold;">
                {{ numberToWordsWrapper(form.pre_payment) }}
              </div>

            </div>



            <hr />

            <!-- اطلاعات کاربر مرتبط -->
            <bita-input type="text" name="user_mobile" label="موبایل کاربری" :validation-container-class="col6"
              input-class="form-control" v-model="form.user_mobile" />

            <bita-input type="password" name="user_password" label="رمز عبور" :validation-container-class="col6"
              input-class="form-control" v-model="form.user_password" />

          </div>
        </div>
      </bita-form>
    </div>

    <div slot="footer">
      <bita-bootbutton v-if="!form.id" type="primary" title="ذخیره" icon="fas fa-save" btn-width="150px"
        @click.native="save" />
      <bita-bootbutton v-else title="بروزرسانی" type="primary" icon="fas fa-save" btn-width="150px"
        @click.native="update" />
    </div>
  </bita-modal>
</template>

<script>
import { numberToWords } from "@/utils/numberToWords";


export default {
  props: {
    title: String,
    isLoading: Boolean,
    doctor: Object,
    degrees: Array,
    specialties: Array,
  },
  data() {
    return {
      col6: "col-lg-6",
      col4: "col-lg-4",
      col12: "col-lg-12",
      form: {
        gender: 1
      },
      genderItems: [
        { text: "مرد", value: 1 },
        { text: "زن", value: 2 },
      ],
    };
  },
  methods: {
    numberToWordsWrapper(num) {
      return numberToWords(num);
    },
    setFormData(formData) {
      this.form = { ...formData };
      // اگر کاربر مرتبط موجود است، مقداردهی فیلدها
      if (formData.user) {
        this.form.user_mobile = formData.user.mobile;
      }
    },
    save() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-create", this.form);
        }
      });
    },
    update() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-update", this.form);
        }
      });
    },
    reset() {
      this.form = {};
      this.$refs.form.reset();
      this.$refs.uploader.reset();
    },
    setErrors(_errors) {
      this.$refs.form.setErrors(_errors);
    },
  },
};
</script>
